/* SEASONS cart extras: ZIP-based free-delivery progress, rotating add-ons, delivery line, notes label */
(function () {
  if (window.__ssCart) return; window.__ssCart = 1;
  var GIFT = 'free-gift-smoked-fish';
  var ESSENTIALS = ['classic-blini', 'creme-fraiche', 'torres-caviar-potato-chips', 'mother-of-pearl-caviar-spoon', 'caviar-butter-french'];
  var KITCHEN = ['salmon-soup', 'tom-yum-soup', 'new-england-clam-chowder', 'salmon-cakes', 'salmon-dumplings', 'rainbow-dumplings', 'hickory-smoked-salmon-spread', 'garlic-herb-butter'];
  var FILL = ['cold-smoked-salmon-yukola', 'cold-smoked-black-pepper-salmon-yukola', 'hot-smoked-salmon', 'three-fish-chess-roll', 'salmon-roe'];
  var MIN = 5000;
  /* Free-delivery thresholds by shipping zone (must match Settings > Shipping) */
  var ZONES = { 1: { free: 9900, fee: 1000, kind: 'next-day' }, 2: { free: 12500, fee: 0, kind: '2-day' }, 3: { free: 20000, fee: 0, kind: '2-day' } };
  /* ZIP3 ranges. Zone 1: NY NJ CT PA MA RI DE MD DC. Zone 2: ME NH VT VA WV NC SC GA OH MI IN IL KY TN AL WI. Everything else (incl. FL): zone 3 */
  var Z1 = [[5, 5], [10, 27], [28, 29], [60, 69], [70, 89], [100, 149], [150, 196], [197, 199], [200, 200], [202, 205], [206, 219], [569, 569]];
  var Z2 = [[30, 38], [39, 49], [50, 59], [201, 201], [220, 246], [247, 268], [270, 289], [290, 299], [300, 319], [398, 399], [350, 369], [370, 385], [400, 427], [430, 458], [460, 479], [480, 499], [530, 549], [600, 629]];
  var cart = null, prods = {}, busy = false, timer = null;
  var onCartPage = /^\/cart\/?$/.test(location.pathname);

  function shuffle(a) { a = a.slice(); for (var i = a.length - 1; i > 0; i--) { var j = Math.floor(Math.random() * (i + 1)); var t = a[i]; a[i] = a[j]; a[j] = t; } return a; }
  var ess = shuffle(ESSENTIALS), kit = shuffle(KITCHEN);
  function money(c) { return '$' + (c / 100).toFixed(2); }
  function money0(c) { return '$' + Math.round(c / 100); }
  function esc(s) { return String(s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }

  function getZip() { try { return localStorage.getItem('ss_zip') || ''; } catch (e) { return window.__ssZip || ''; } }
  function setZip(z) { window.__ssZip = z; try { if (z) localStorage.setItem('ss_zip', z); else localStorage.removeItem('ss_zip'); } catch (e) {} }
  function inR(p, list) { for (var i = 0; i < list.length; i++) if (p >= list[i][0] && p <= list[i][1]) return true; return false; }
  function zoneOf(zip) { var p = parseInt(zip.slice(0, 3), 10); if (isNaN(p)) return 3; return inR(p, Z1) ? 1 : inR(p, Z2) ? 2 : 3; }

  function shipHtml() {
    var zip = getZip();
    if (!/^\d{5}$/.test(zip)) {
      return '<p class="ss-cx__title">&#128666; See your FREE delivery amount</p>' +
        '<div class="ss-zip"><input class="ss-zip__in" type="text" inputmode="numeric" pattern="[0-9]*" maxlength="5" autocomplete="postal-code" placeholder="Enter delivery ZIP" aria-label="Delivery ZIP code">' +
        '<button type="button" class="ss-zip__btn">Check</button></div>';
    }
    var Z = ZONES[zoneOf(zip)], FREE = Z.free, sub = cart.items_subtotal_price;
    var feeTxt = Z.fee ? money0(Z.fee) : 'rate at checkout';
    var where = '<div class="ss-zip__to">Delivery to ' + esc(zip) + (sub >= FREE ? (Z.kind === '2-day' ? ' · next-day express at checkout' : '') : ': ' + feeTxt) + ' · <button type="button" class="ss-zip__change">Change</button></div>';
    if (sub >= FREE) return '<p class="ss-cx__title">&#10003; You get FREE ' + Z.kind + ' delivery</p>' + where;
    var p = Math.max(4, Math.min(100, Math.round(sub / FREE * 100)));
    return '<p class="ss-cx__title">FREE ' + Z.kind + ' delivery on orders ' + money0(FREE) + '+</p><div class="ss-cx__line"><span>Add <strong>' + money(FREE - sub) + '</strong> more to get it</span><span class="ss-cx__of">' + money(sub) + ' / ' + money0(FREE) + '</span></div><div class="ss-cx__bar"><span style="width:' + p + '%"></span></div>' + where;
  }

  function saveZip(box) {
    var inp = box && box.querySelector('.ss-zip__in'); if (!inp) return;
    var z = (inp.value || '').replace(/\D/g, '').slice(0, 5);
    if (z.length !== 5) { inp.classList.add('is-bad'); inp.focus(); return; }
    setZip(z); ensure();
  }
  document.addEventListener('click', function (e) {
    var b = e.target.closest('.ss-zip__btn');
    if (b) { e.preventDefault(); saveZip(b.closest('.ss-cx')); return; }
    var c = e.target.closest('.ss-zip__change');
    if (c) { e.preventDefault(); setZip(''); ensure(); var i = document.querySelector('.ss-zip__in'); if (i) i.focus(); }
  }, true);
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Enter' && e.target.classList && e.target.classList.contains('ss-zip__in')) { e.preventDefault(); saveZip(e.target.closest('.ss-cx')); }
  }, true);
  document.addEventListener('input', function (e) {
    if (e.target.classList && e.target.classList.contains('ss-zip__in')) {
      e.target.classList.remove('is-bad');
      var v = e.target.value.replace(/\D/g, '').slice(0, 5); if (v !== e.target.value) e.target.value = v;
      if (v.length === 5) saveZip(e.target.closest('.ss-cx'));
    }
  }, true);

  function minModal(sub) {
    var m = document.getElementById('ss-min');
    if (!m) {
      m = document.createElement('div'); m.id = 'ss-min'; m.className = 'ss-min'; m.setAttribute('role', 'dialog'); m.setAttribute('aria-modal', 'true');
      m.innerHTML = '<div class="ss-min__box"><p class="ss-min__title">Minimum order is ' + money(MIN) + '</p><p class="ss-min__text"></p><button type="button" class="ss-min__btn">Keep shopping</button></div>';
      document.body.appendChild(m);
      m.addEventListener('click', function (e) { if (e.target === m || e.target.closest('.ss-min__btn')) m.classList.remove('is-open'); });
    }
    m.querySelector('.ss-min__text').innerHTML = 'Add <strong>' + money(MIN - sub) + '</strong> more to check out.';
    m.classList.add('is-open'); m.querySelector('.ss-min__btn').focus();
  }
  function blockCheckout(e) {
    var t = e.type === 'submit' ? e.submitter : e.target.closest('button[name="checkout"], input[name="checkout"], #checkout, #CartDrawer-Checkout, a[href^="/checkout"]');
    if (!t || (t.name !== 'checkout' && !t.matches('#checkout, #CartDrawer-Checkout, a[href^="/checkout"]'))) return;
    if (!cart || !cart.items.length || cart.items_subtotal_price >= MIN) return;
    e.preventDefault(); e.stopImmediatePropagation(); minModal(cart.items_subtotal_price);
  }
  document.addEventListener('click', blockCheckout, true);
  document.addEventListener('submit', blockCheckout, true);
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') { var m = document.getElementById('ss-min'); if (m) m.classList.remove('is-open'); } });

  function gapNow() {
    var zip = getZip(); if (!cart || !/^\d{5}$/.test(zip)) return null;
    var Z = ZONES[zoneOf(zip)], sub = cart.items_subtotal_price;
    return sub < Z.free ? { gap: Z.free - sub, kind: Z.kind } : null;
  }
  function picks() {
    var inCart = {}; cart.items.forEach(function (i) { inCart[i.handle] = 1; });
    var g = gapNow();
    if (g) {
      /* Fill the gap to FREE delivery: first items that cover it (cheapest first), then the biggest ones */
      var pool = ess.concat(kit, FILL).filter(function (h, i, a) { return a.indexOf(h) === i && !inCart[h] && prods[h] && prods[h].available; });
      var cover = pool.filter(function (h) { return prods[h].price >= g.gap; }).sort(function (x, y) { return prods[x].price - prods[y].price; });
      var rest = pool.filter(function (h) { return prods[h].price < g.gap; }).sort(function (x, y) { return prods[y].price - prods[x].price; });
      var sel = cover.concat(rest).slice(0, 3);
      if (sel.length) return sel;
    }
    var hasCaviar = cart.items.some(function (i) { return /caviar|roe/i.test(i.product_type || '') || /caviar|salmon-roe/.test(i.handle); });
    var a = ess.filter(function (h) { return !inCart[h] && (!prods[h] || prods[h].available); });
    var b = kit.filter(function (h) { return !inCart[h] && (!prods[h] || prods[h].available); });
    var out = hasCaviar ? a.slice(0, 2).concat(b.slice(0, 1)) : b.slice(0, 2).concat(a.slice(0, 1));
    return out.slice(0, 3);
  }

  function upHtml() {
    var list = picks();
    if (!list.length) return '';
    var ready = list.filter(function (h) { return prods[h]; });
    if (ready.length < list.length) { load(list); if (!ready.length) return ''; }
    return '<p class="ss-cx__title">Add to your order</p><div class="ss-cx__row">' + ready.map(function (h) {
      var p = prods[h];
      return '<div class="ss-cx__item"><a class="ss-cx__img" href="/products/' + h + '"><img src="' + esc(p.img) + '" alt="" loading="lazy" width="120" height="120"></a><div class="ss-cx__info"><a class="ss-cx__name" href="/products/' + h + '">' + esc(p.title) + '</a><span class="ss-cx__price">' + money(p.price) + '</span></div><button type="button" class="ss-cx__add" data-ss-add="' + p.id + '" aria-label="Add ' + esc(p.title) + '">+ Add</button></div>';
    }).join('') + '</div>';
  }

  var loading = {};
  function load(list) {
    list.forEach(function (h) {
      if (prods[h] || loading[h]) return; loading[h] = 1;
      fetch('/products/' + h + '.js').then(function (r) { return r.json(); }).then(function (d) {
        var v = (d.variants || []).filter(function (x) { return x.available; })[0] || d.variants[0];
        var img = d.featured_image || '';
        if (img && img.indexOf('//') === 0) img = 'https:' + img;
        if (img) img += (img.indexOf('?') > -1 ? '&' : '?') + 'width=160';
        prods[h] = { id: v.id, title: d.title, price: v.price, available: d.available, img: img };
        ensure();
      }).catch(function () {});
    });
  }

  function place(cls, before) {
    var el = before.parentNode.querySelector(':scope > .' + cls);
    if (!el) { el = document.createElement('div'); el.className = 'ss-cx ' + cls; before.parentNode.insertBefore(el, before); }
    return el;
  }
  function setHtml(el, h) {
    if (el.__h !== h) {
      var a = document.activeElement, keep = a && a.classList && a.classList.contains('ss-zip__in') && el.contains(a) ? a.value : null;
      el.innerHTML = h; el.__h = h;
      if (keep !== null) { var n = el.querySelector('.ss-zip__in'); if (n) { n.value = keep; n.focus(); } }
    }
    el.style.display = h ? '' : 'none'; el.classList.toggle('is-busy', busy);
  }

  var NOTE = 'Order special instructions', NOTE2 = 'Gift message or delivery notes';
  function ensure() {
    if (!cart) return;
    var empty = !cart.items.filter(function (i) { return i.handle !== GIFT; }).length;
    var ship = empty ? '' : shipHtml(), up = empty ? '' : upHtml();
    var footer = document.querySelector('cart-drawer .drawer__footer');
    if (footer) {
      var anchor = footer.parentNode.querySelector(':scope > .ss-gift') || footer;
      setHtml(place('ss-cx--ship', anchor), ship);
      var form = document.querySelector('cart-drawer .cart-drawer__form');
      if (form) {
        var ue = form.querySelector(':scope > .ss-cx--up');
        if (!ue) { ue = document.createElement('div'); ue.className = 'ss-cx ss-cx--up'; form.appendChild(ue); }
        setHtml(ue, up);
      }
    }
    /* Last nudge right above the checkout button */
    var g = empty ? null : gapNow();
    var nudge = g ? '<p class="ss-nudge__t" style="margin:0 0 .8rem;text-align:center;font-size:1.35rem;line-height:1.35">&#128666; You\'re <strong>' + money(g.gap) + '</strong> away from <strong>FREE ' + g.kind + ' delivery</strong></p>' : '';
    [document.getElementById('CartDrawer-Checkout'), document.querySelector('#main-cart-footer #checkout')].forEach(function (b) {
      if (!b) return;
      var box = b.closest('.cart__ctas') || b.parentNode;
      var el = box.parentNode.querySelector(':scope > .ss-nudge');
      if (!el) { el = document.createElement('div'); el.className = 'ss-nudge'; box.parentNode.insertBefore(el, box); }
      if (el.__h !== nudge) { el.innerHTML = nudge; el.__h = nudge; }
      el.style.display = nudge ? '' : 'none';
    });
    var pf = document.getElementById('main-cart-footer');
    if (pf) {
      var a2 = document.querySelector('.ss-gift--page') || pf;
      var u2 = place('ss-cx--up', a2); u2.classList.add('page-width'); setHtml(u2, up);
      var s2 = place('ss-cx--ship', a2); s2.classList.add('page-width'); setHtml(s2, ship);
    }
    [document.querySelector('cart-drawer'), document.getElementById('main-cart-footer')].forEach(function (root) {
      if (!root) return;
      var tw = document.createTreeWalker(root, NodeFilter.SHOW_TEXT), n;
      while ((n = tw.nextNode())) { if (n.nodeValue.trim() === NOTE) n.nodeValue = n.nodeValue.replace(NOTE, NOTE2); }
    });
  }

  function refresh() {
    clearTimeout(timer);
    timer = setTimeout(function () {
      origFetch('/cart.js', { credentials: 'same-origin' }).then(function (r) { return r.json(); }).then(function (c) { cart = c; ensure(); });
    }, 300);
  }

  function apply(res) {
    if (onCartPage) { location.reload(); return; }
    var d = document.querySelector('cart-drawer');
    if (res && res.sections && d) {
      var p = new DOMParser();
      if (res.sections['cart-drawer']) {
        var n = p.parseFromString(res.sections['cart-drawer'], 'text/html').querySelector('#CartDrawer');
        var c = document.getElementById('CartDrawer');
        if (n && c) { c.innerHTML = n.innerHTML; var ov = c.querySelector('#CartDrawer-Overlay'); if (ov) ov.addEventListener('click', function () { d.close(); }); }
        d.classList.remove('is-empty');
      }
      if (res.sections['cart-icon-bubble']) {
        var b = document.getElementById('cart-icon-bubble'), s = p.parseFromString(res.sections['cart-icon-bubble'], 'text/html').querySelector('.shopify-section');
        if (b && s) b.innerHTML = s.innerHTML;
      }
    }
    refresh();
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-ss-add]');
    if (!btn || busy) return;
    e.preventDefault(); e.stopPropagation();
    busy = true; btn.textContent = 'Adding...'; ensure();
    origFetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: +btn.getAttribute('data-ss-add'), quantity: 1 }], sections: 'cart-drawer,cart-icon-bubble', sections_url: location.pathname }) })
      .then(function (r) { return r.json(); }).then(function (res) { busy = false; apply(res); })
      .catch(function () { busy = false; refresh(); });
  }, true);

  var origFetch = window.fetch.bind(window);
  var wrapped = window.fetch;
  window.fetch = function (u, o) {
    var p = wrapped(u, o), s = typeof u === 'string' ? u : (u && u.url) || '';
    if (/\/cart\/(add|change|update|clear)/.test(s)) p.then(function () { refresh(); });
    return p;
  };

  /* Add to cart: keep shopping. Drawer does not auto-open; a short toast + cart icon bounce instead */
  (function () {
    var css = '.ss-toast{position:fixed;left:50%;top:calc(10px + env(safe-area-inset-top));z-index:2147483001;display:flex;align-items:center;gap:10px;width:calc(100% - 24px);max-width:420px;padding:10px 10px 10px 12px;border-radius:14px;background:#17201C;color:#fff;box-shadow:0 10px 30px rgba(0,0,0,.25);font-size:1.35rem;line-height:1.3;transform:translate(-50%,-140%);opacity:0;transition:transform .3s ease,opacity .3s ease;pointer-events:none}' +
      '.ss-toast.is-on{transform:translate(-50%,0);opacity:1;pointer-events:auto}' +
      '.ss-toast__img{flex:none;width:40px;height:40px;border-radius:8px;object-fit:cover;background:#F5F3EE}' +
      '.ss-toast__txt{flex:1 1 auto;min-width:0}.ss-toast__txt b{display:block;font-weight:700}.ss-toast__txt span{display:block;opacity:.8;white-space:nowrap;overflow:hidden;text-overflow:ellipsis}' +
      '.ss-toast__btn{flex:none;min-height:3.6rem;padding:0 1.2rem;border:0;border-radius:9px;background:#fff;color:#17201C;font:inherit;font-weight:700;cursor:pointer}' +
      '@keyframes ssBump{0%,100%{transform:scale(1)}40%{transform:scale(1.25)}70%{transform:scale(.95)}}#cart-icon-bubble.ss-bump{animation:ssBump .6s ease}';
    var st = document.createElement('style'); st.textContent = css; document.head.appendChild(st);
    var el = null, hideT = null;
    function drawer() { return document.querySelector('cart-drawer'); }
    function hide() { if (el) el.classList.remove('is-on'); }
    function toast(state) {
      if (!el) {
        el = document.createElement('div'); el.className = 'ss-toast'; el.setAttribute('role', 'status'); el.setAttribute('aria-live', 'polite');
        document.body.appendChild(el);
        el.addEventListener('click', function (e) {
          if (!e.target.closest('.ss-toast__btn')) return;
          hide(); var d = drawer(); if (d) d.open(document.getElementById('cart-icon-bubble'));
        });
      }
      var img = state && (state.image || (state.featured_image && state.featured_image.url)) || '';
      if (img && img.indexOf('//') === 0) img = 'https:' + img;
      if (img) img += (img.indexOf('?') > -1 ? '&' : '?') + 'width=96';
      var title = state && (state.product_title || state.title) || '';
      el.innerHTML = (img ? '<img class="ss-toast__img" src="' + esc(img) + '" alt="">' : '') +
        '<div class="ss-toast__txt"><b>&#10003; Added to cart</b>' + (title ? '<span>' + esc(title) + '</span>' : '') + '</div>' +
        '<button type="button" class="ss-toast__btn">View cart</button>';
      void el.offsetWidth; el.classList.add('is-on');
      clearTimeout(hideT); hideT = setTimeout(hide, 4000);
      var b = document.getElementById('cart-icon-bubble');
      if (b) { b.classList.remove('ss-bump'); void b.offsetWidth; b.classList.add('ss-bump'); }
    }
    function patch() {
      var CD = customElements.get('cart-drawer');
      if (!CD || CD.prototype.__ssPatched) return; CD.prototype.__ssPatched = 1;
      var origOpen = CD.prototype.open, origRender = CD.prototype.renderContents;
      CD.prototype.open = function (t) { if (this.__ssHold) return; hide(); return origOpen.call(this, t); };
      CD.prototype.renderContents = function (state) {
        var self = this; self.__ssHold = true;
        try { origRender.call(this, state); } finally { setTimeout(function () { self.__ssHold = false; }, 80); }
        toast(state);
      };
    }
    if (window.customElements) customElements.whenDefined('cart-drawer').then(patch);
  })();

  /* iPhone: stop the page from zooming in when a field is tapped (pinch-zoom still works) */
  (function () {
    if (!/iPhone|iPad|iPod/.test(navigator.userAgent)) return;
    var m = document.querySelector('meta[name=viewport]');
    if (m && !/maximum-scale/.test(m.content)) m.content = m.content + ',maximum-scale=1';
  })();
  new MutationObserver(function () { ensure(); }).observe(document.body, { childList: true, subtree: true });
  load(ess.concat(kit, FILL));
  refresh();
})();
